/* English versions of the legal texts. German originals live in Legal.jsx. */
export const ADDR = "Tim-Niklas Kubach\nLugbank 6\n96049 Bamberg\nGermany";

